// Layout khu Bói Đê (/tong-hop) — màn bói nhanh và các template.
// slug "tong-hop" chỉ còn dùng để mở lại phiên tổng hợp cũ.
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/tong-hop")({
  head: () => ({
    meta: [
      { title: "Bói Đê - Xem Tình Duyên, Sự Nghiệp, Tài Lộc, Ngày Tốt Bằng AI" },
      {
        name: "description",
        content:
          "Nhập một câu hỏi, chọn template nếu cần và nhận lời luận Bói Đê. Gieo quẻ Kinh Dịch là tùy chọn, mặc định tắt.",
      },
    ],
  }),
  component: () => <Outlet />,
});
